import Immutable from 'immutable';
import { createSelector } from 'reselect';

const getUserTransactions = state => state.getIn(['bibs', 'userTransactions'], Immutable.Map());

export const selectPremiumSuggestionsSummary = createSelector([getUserTransactions], userTransactions =>
  userTransactions.getIn(['suggestForPurchase', 'premiumSuggestions', 'summary'], Immutable.Map())
);

export default {
  selectPremiumSuggestionsSummary
};
